var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Select, Spin } from 'antd';
import * as React from 'react';
import stores from 'src/stores/stores';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: true,
            options: []
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            loading: false,
            options: stores.constant.model.filter(function (c) { return c.group === _this.props.group; })
        });
    };
    default_1.prototype.render = function () {
        return (React.createElement(Select, __assign({}, this.props, { showSearch: true, filterOption: function (input, option) {
                return option.props.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0;
            }, notFoundContent: this.state.loading ? React.createElement(Spin, { size: "small" }) : null }), this.state.options.map(function (c) { return (React.createElement(Select.Option, { key: c.id, value: c.id }, c.name)); })));
    };
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ConstantField.tsx
// module id = 307
// module chunks = 0